import { TYPE_TRACK } from '@chama/utils/functions/analytics';
import {
  MUTE_ORDER_SOUND,
  UNMUTE_ORDER_SOUND,
  SOUND_PLAYBACK,
  SOUND_WARNING_DISMISSED,
} from '@app/actions/order-sound';

const initialState = {
  isSoundMuted: false,
  hasUserInteractedWithPage: false,
};

const orderSound = (state = initialState, action) => {
  switch (action.type) {
    case MUTE_ORDER_SOUND:
      return {
        ...state,
        isSoundMuted: true,
        hasUserInteractedWithPage: true,
      };

    case UNMUTE_ORDER_SOUND:
      return {
        ...state,
        isSoundMuted: false,
        hasUserInteractedWithPage: true,
      };
    case TYPE_TRACK:
      return changeUserInteractionWithPage(state, action);

    default:
      return state;
  }
};

function changeUserInteractionWithPage(state, { payload }) {
  const shouldSkip = !payload || ![SOUND_WARNING_DISMISSED, SOUND_PLAYBACK].includes(payload.name);

  if (shouldSkip) return state;

  const { properties } = payload;

  return {
    ...state,
    hasUserInteractedWithPage: payload.name === SOUND_WARNING_DISMISSED || properties.isPlayed,
  };
}

export default orderSound;



// WEBPACK FOOTER //
// ./src/reducer/order-sound.js